import React, { ChangeEvent, useRef } from "react";
import Table from "../Table";
import { CONSTANTS } from "../../constants/Constants";
import VideoModal from "../VideoModal";
import Button from "../Buttons";

interface MediaComponentProps {
  payload: any;
  mediaChangeHandler: (e: ChangeEvent) => void;
  setPayload: any;
  saveMediaHandler: () => void;
  isModalOpen: boolean;
  setIsModalOpen: any;
  newVideo: any;
  setNewVideo: any;
  setCurrentIndex: any;
  isLinkDisabled?: boolean
  isMediaDisabled?: boolean
  removeMediaFileHandler: () => void
  setIsMediaDisabled: any
  setIsLinkDisabled: any
}

const MediaComponent: React.FC<MediaComponentProps> = ({
  payload,
  mediaChangeHandler,
  setPayload,
  saveMediaHandler,
  isModalOpen,
  setIsModalOpen,
  newVideo,
  setCurrentIndex,
  setNewVideo,
  isLinkDisabled,
  isMediaDisabled,
  setIsMediaDisabled,
  setIsLinkDisabled,
  removeMediaFileHandler
}) => {
  const dragItem = useRef<number | null>(null);
  const dragOverItem = useRef<number | null>(null);

  const handleDragEnd = () => {
    if (
      dragItem.current !== null &&
      dragOverItem.current !== null &&
      dragItem.current !== dragOverItem.current
    ) {
      const updatedVideos = [
        ...payload?.[
        CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA
        ],
      ];
      const [draggedItem] = updatedVideos.splice(dragItem.current, 1);
      updatedVideos.splice(dragOverItem.current, 0, draggedItem);

      // Update positions
      const updatedVideosWithPosition = updatedVideos.map((video, index) => ({
        ...video,
        position: index + 1,
      }));

      // setVideos(updatedVideosWithPosition);
      setPayload({
        ...payload,
        [CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA]:
          updatedVideosWithPosition,
      });
    }

    dragItem.current = null;
    dragOverItem.current = null;
  };
  const filteredRows = payload?.[
    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA
  ]?.map((media: any) => ({
    title: media[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME],
    description:
      media[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DESCRIPTION],
    status: media[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS],
  }));

  return (
    <div className="lg:p-6">
      <h2 className="text-2xl font-semibold mb-4">
        {CONSTANTS.UPLOADED_VIDEOS}
      </h2>
      <div className="overflow-auto">
        <Table
          dragItem={dragItem}
          tableHeader={filteredRows.length > 0 ? [
            CONSTANTS.TITLE_TXT,
            CONSTANTS.DESCRIPTION_TXT,
            CONSTANTS.SHOW_ON_PROFILE_TXT,
          ] : []}
          tableRows={filteredRows}
          dragEndHandler={handleDragEnd}
          dragOverItem={dragOverItem}
          rowClickHandler={(index) => {
            setNewVideo(
              payload[
              CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.RESOURCE_MEDIA
              ][index]
            );
            setCurrentIndex(index);
            setIsModalOpen(true);
          }}
        />
      </div>
      <div className="w-32 mt-4">
        <Button
          btn_label={CONSTANTS.ADD_MORE}
          on_click_handler={() => {
            setIsModalOpen(true);
            setNewVideo({
              status: CONSTANTS.ENABLED_TXT.toLocaleUpperCase(),
            });
            setCurrentIndex(null);
            setIsLinkDisabled(false)
            setIsMediaDisabled(false)

          }}
          other_classes={"!rounded"}
          type={"primary"}
        />
      </div>

      {isModalOpen && (
        <VideoModal
          payload={newVideo}
          setIsModalOpen={setIsModalOpen}
          mediaChangeHandler={mediaChangeHandler}
          saveMediaHandler={saveMediaHandler}
          isLinkDisabled={isLinkDisabled}
          isMediaDisabled={isMediaDisabled}
          removeMediaFileHandler={removeMediaFileHandler}
        />
      )}
    </div>
  );
};

export default MediaComponent;
